import { get as getItem, set as setItem, del as removeItem } from 'idb-keyval';

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export function createIDBPersister() {
    return { getItem, setItem, removeItem };
}
